(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["layered-slideshow"] && !Shopify.designMode) return;
  try {
    
(() => {
  const INIT = new WeakSet();

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function getTabs(root) {
    return Array.from(root.querySelectorAll('[role="tab"]'));
  }

  function getPanels(root) {
    const byRole = Array.from(root.querySelectorAll('[role="tabpanel"]'));
    if (byRole.length) return byRole;
    return Array.from(root.querySelectorAll('.layered-slideshow__panel'));
  }

  function clampIndex(i, total) {
    if (!total) return 0;
    return ((i % total) + total) % total;
  }

  function getActiveIndex(root) {
    const tabs = getTabs(root);
    const current = tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true');
    if (current >= 0) return current;

    const fromData = Number(root.dataset.activeIndex);
    return Number.isFinite(fromData) ? fromData : 0;
  }

  function setActive(root, index) {
    const container = root.querySelector('.layered-slideshow__container');
    const tabs = getTabs(root);
    const panels = getPanels(root);
    const total = tabs.length;

    if (!container || !total) return;

    const nextIndex = clampIndex(index, total);

    tabs.forEach((tab, i) => {
      const selected = i === nextIndex;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
    });

    // Inert everything except active panel (helps a11y and your CSS hooks)
    if (panels.length === total) {
      panels.forEach((panel, i) => {
        if (i === nextIndex) panel.removeAttribute('inert');
        else panel.setAttribute('inert', '');
      });
    }

    // Update grid sizes so the active slide is expanded on both desktop + mobile
    const mobile = isMobile();
    const template = Array.from({ length: total }, (_, i) => {
      if (mobile) return i === nextIndex ? 'var(--active-panel-height)' : 'var(--button-height)';
      return i === nextIndex ? 'var(--active-panel-width)' : 'var(--button-width)';
    }).join(' ');

    container.style.setProperty('--active-tab', template);
    root.dataset.activeIndex = String(nextIndex);
  }

  function stopAutoplay(root) {
    if (!root._layeredTimer) return;
    window.clearInterval(root._layeredTimer);
    root._layeredTimer = null;
  }

  function startAutoplay(root) {
    if (prefersReducedMotion()) return;
    if (document.hidden) return;
    if (root._layeredTimer) return;
    if (root.dataset.autoplay !== 'true') return;

    const interval = Number(root.dataset.interval) || 2000;

    root._layeredTimer = window.setInterval(() => {
      const total = getTabs(root).length;
      if (!total) return;
      setActive(root, clampIndex(getActiveIndex(root) + 1, total));
    }, interval);
  }

  function resumeAutoplaySoon(root) {
    if (root._layeredResumeTimer) window.clearTimeout(root._layeredResumeTimer);
    // Small delay so autoplay doesn't fight the user
    root._layeredResumeTimer = window.setTimeout(() => startAutoplay(root), 2500);
  }

  function init(root) {
    if (INIT.has(root)) return;
    INIT.add(root);

    const container = root.querySelector('.layered-slideshow__container');
    if (!container) return;

    // Initial state (works for both desktop + mobile)
    setActive(root, getActiveIndex(root));

    // Click / tap to select (desktop + mobile)
    root.addEventListener('click', (e) => {
      const btn = e.target.closest?.('[role="tab"]');
      if (!btn || !root.contains(btn)) return;

      const tabs = getTabs(root);
      const idx = tabs.indexOf(btn);
      if (idx >= 0) setActive(root, idx);

      stopAutoplay(root);
      resumeAutoplaySoon(root);
    });

    // Swipe support (mobile)
    if (root.dataset.swipe === 'true') {
      let sx = 0;
      let sy = 0;
      let st = 0;

      root.addEventListener(
        'touchstart',
        (e) => {
          const t = e.touches?.[0];
          if (!t) return;
          sx = t.clientX;
          sy = t.clientY;
          st = Date.now();
          stopAutoplay(root);
        },
        { passive: true }
      );

      root.addEventListener(
        'touchend',
        (e) => {
          const t = e.changedTouches?.[0];
          if (!t) return;

          const dx = t.clientX - sx;
          const dy = t.clientY - sy;
          const dt = Date.now() - st;

          if (dt < 700 && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            const dir = dx < 0 ? 1 : -1;
            const total = getTabs(root).length;
            setActive(root, clampIndex(getActiveIndex(root) + dir, total));
          }

          resumeAutoplaySoon(root);
        },
        { passive: true }
      );
    }

    // Keep correct layout when crossing the 749px breakpoint
    const mq = window.matchMedia('(max-width: 749px)');
    const onChange = () => setActive(root, getActiveIndex(root));
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);

    // Autoplay on BOTH desktop + mobile
    if (root.dataset.autoplay === 'true' && !prefersReducedMotion()) {
      startAutoplay(root);
    }

    // Pause when tab is hidden
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay(root);
      else startAutoplay(root);
    });

    // Pause on hover/focus (desktop usability)
    root.addEventListener('mouseenter', () => stopAutoplay(root));
    root.addEventListener('mouseleave', () => startAutoplay(root));
    root.addEventListener('focusin', () => stopAutoplay(root));
    root.addEventListener('focusout', () => startAutoplay(root));
  }

  function boot() {
    document.querySelectorAll('layered-slideshow-component').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify theme editor reloads sections dynamically
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
